<script lang="ts" setup>
import GwText from '@/components/lib/base/GwText/GwText.vue'
import { type TextVariants } from '@/components/lib/base/GwText/gwTextVariants'

export interface StatRowProps {
  title?: string
  value: string | number
  unit?: string
  loading?: boolean
  bottomText?: {
    value: string
    variant: TextVariants
  }
}
defineProps<StatRowProps>()
</script>

<template>
  <div class="f-column">
    <GwText
      :data-tst="`stat_${title ? title.toLowerCase() : value.toString().toLowerCase()}${loading ? '_loading' : ''}`"
      variant="text_white_largest_700"
      class="text-nowrap"
    >
      {{ value }} <GwText variant="text_white_normal_500">{{ unit }}</GwText>
    </GwText>
    <GwText
      v-if="bottomText"
      :key="bottomText.value"
      :variant="bottomText.variant"
    >
      {{ bottomText.value }}
    </GwText>
  </div>
</template>

<style scoped lang="scss"></style>
